<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>督导工作移交</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>督导工作移交</span>
      </div>

      <!-- 筹建督导工作移交 -->
      <el-form :inline="true" size="small">
        <el-form-item label="移交方：">
          <el-select v-model="fromId" placeholder="请选择移交方" clearable @change="onFromChange">
            <el-option
              v-for="emp in supervisors"
              :key="emp._id"
              :label="emp.name + ' (' + emp.department + ')'"
              :value="emp._id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="接收方：">
          <el-select v-model="toId" placeholder="请选择接收方" clearable>
            <el-option
              v-for="emp in supervisors"
              :key="emp._id"
              :label="emp.name + ' (' + emp.department + ')'"
              :value="emp._id"
              :disabled="emp._id === fromId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleTransferAll" :disabled="!fromId || !toId">一键移交</el-button>
          <el-button type="warning" @click="handleTransferByProjects" :disabled="!fromId || !toId">按项目移交</el-button>
        </el-form-item>
      </el-form>

      <div v-if="showProjectTable" style="margin-top: 20px">
        <div style="margin-bottom: 10px; display: flex; align-items: center; justify-content: space-between">
          <span style="font-weight: bold">
            督导负责的项目列表（共 {{ projectList.length }} 个，已选 {{ selectedProjects.length }} 个）
          </span>
          <el-input
            v-model="projectKeyword"
            placeholder="搜索项目名称/客户名称"
            prefix-icon="el-icon-search"
            clearable
            size="small"
            style="width: 280px"
          ></el-input>
        </div>
        <el-table
          :data="filteredProjectList"
          border
          @selection-change="handleSelectionChange"
          ref="projectTable"
          height="calc(100vh - 400px)"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="项目名称" prop="projectName"></el-table-column>
          <el-table-column label="客户名称" prop="customerName"></el-table-column>
          <el-table-column label="签约类型" prop="signType"></el-table-column>
          <el-table-column label="进度">
            <template slot-scope="scope">
              {{ progressText(scope.row.progress) }}
            </template>
          </el-table-column>
          <el-table-column label="签约时间">
            <template slot-scope="scope">
              {{ scope.row.dealDate | date }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 筹建督导
      supervisors: [],
      fromId: '',
      toId: '',
      projectList: [],
      selectedProjects: [],
      showProjectTable: false,
      projectKeyword: ''
    }
  },
  computed: {
    filteredProjectList () {
      if (!this.projectKeyword) return this.projectList
      const kw = this.projectKeyword.toLowerCase()
      return this.projectList.filter(p =>
        (p.projectName && p.projectName.toLowerCase().includes(kw)) ||
        (p.customerName && p.customerName.toLowerCase().includes(kw))
      )
    }
  },
  created () {
    this.getSupervisors()
  },
  methods: {
    progressText (progress) {
      const map = {}
      map[-2] = '解约'
      map[-1] = '退款'
      map[0] = '成交'
      map[1] = '筹建中'
      map[2] = '开业中'
      return map[progress] || '未知'
    },

    // ===== 筹建督导方法 =====
    async getSupervisors () {
      const { data: res } = await this.$http.get('dudao/workTransfer/supervisors')
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.supervisors = res.data
    },

    onFromChange (val) {
      this.selectedProjects = []
      this.projectKeyword = ''
      if (val) {
        this.loadProjects()
      } else {
        this.showProjectTable = false
        this.projectList = []
      }
    },

    async loadProjects () {
      if (!this.fromId) return
      const { data: res } = await this.$http.get('dudao/workTransfer/projects', {
        params: { supervisorId: this.fromId }
      })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.projectList = res.data.list
      this.showProjectTable = true
    },

    handleSelectionChange (val) {
      this.selectedProjects = val
    },

    async handleTransferAll () {
      if (!this.fromId || !this.toId) {
        return this.$message.warning('请选择移交方和接收方')
      }

      const fromName = this.supervisors.find(e => e._id === this.fromId).name
      const toName = this.supervisors.find(e => e._id === this.toId).name

      try {
        await this.$confirm(
          `是否确定要将【${fromName}】的筹建数据移交给【${toName}】`,
          '提示',
          { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
        )
      } catch {
        return
      }

      const { data: res } = await this.$http.post('dudao/workTransfer/transferAll', {
        fromId: this.fromId,
        toId: this.toId
      })

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success(`移交成功，共移交 ${res.data.projectCount} 个项目`)
      this.showProjectTable = false
      this.projectList = []
      this.selectedProjects = []
    },

    async handleTransferByProjects () {
      if (!this.fromId || !this.toId) {
        return this.$message.warning('请选择移交方和接收方')
      }
      if (this.selectedProjects.length === 0) {
        return this.$message.warning('请至少选择一个项目')
      }

      const toName = this.supervisors.find(e => e._id === this.toId).name

      try {
        await this.$confirm(
          `是否确定要将所选项目移交给【${toName}】`,
          '提示',
          { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
        )
      } catch {
        return
      }

      const projectIds = this.selectedProjects.map(p => p._id)

      const { data: res } = await this.$http.post('dudao/workTransfer/transferByProjects', {
        fromId: this.fromId,
        toId: this.toId,
        projectIds
      })

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success(`移交成功，共移交 ${res.data.projectCount} 个项目`)
      this.loadProjects()
    }
  }
}
</script>

<style lang="less" scoped>
.clearfix::after {
  content: '';
  display: table;
  clear: both;
}
</style>
